import Icon from '@/components/ui/AppIcon';
import AppImage from '@/components/ui/AppImage';

interface Certification {
  name: string;
  image: string;
  alt: string;
}

interface ClientLogo {
  name: string;
  image: string;
  alt: string;
}

const TrustSignals = () => {
  const certifications: Certification[] = [
  {
    name: 'ISO 27001',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_13e3faf4c-1764641705752.png",
    alt: 'ISO 27001 information security management certification badge with blue and white design'
  },
  {
    name: 'Microsoft Partner',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1681c7e8e-1767956281095.png",
    alt: 'Microsoft Gold Partner certification logo with colorful squares representing partnership level'
  },
  {
    name: 'AWS Certified',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c6f823c9-1766490772201.png",
    alt: 'Amazon Web Services certified solutions architect badge with orange and black design'
  },
  {
    name: 'CompTIA',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1f7e704de-1767089187776.png",
    alt: 'CompTIA Security Plus certification badge with red and white professional design'
  }];


  const clientLogos: ClientLogo[] = [
  {
    name: 'HealthTech Solutions',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1e4951f45-1764669835430.png",
    alt: 'HealthTech Solutions company logo with medical cross symbol in blue and white'
  },
  {
    name: 'FinanceFirst Bank',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_174bfd06d-1769355060468.png",
    alt: 'FinanceFirst Bank corporate logo with shield emblem representing financial security'
  },
  {
    name: 'Manufacturing Plus',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1758dc0b4-1766983670105.png",
    alt: 'Manufacturing Plus industrial company logo with gear icon in gray and orange'
  },
  {
    name: 'RetailHub Inc',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_179e69db4-1766508110373.png",
    alt: 'RetailHub Inc modern retail brand logo with shopping cart symbol in vibrant colors'
  },
  {
    name: 'EduTech Academy',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1d0ea767a-1764660286639.png",
    alt: 'EduTech Academy educational institution logo with graduation cap icon in blue'
  },
  {
    name: 'Global Logistics',
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1ad68353f-1767333914436.png",
    alt: 'Global Logistics company logo with world map and arrow design in green and blue'
  }];


  const stats = [
  { icon: 'UserGroupIcon', value: '500+', label: 'Active Clients' },
  { icon: 'ClockIcon', value: '15 min', label: 'Avg Response Time' },
  { icon: 'ChartBarIcon', value: '99.9%', label: 'System Uptime' },
  { icon: 'ShieldCheckIcon', value: '100%', label: 'Security Compliance' }];


  return (
    <section className="py-20 bg-gradient-to-b from-muted to-card">
      <div className="container mx-auto px-4">
        {/* Stats Section */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, index) =>
          <div
            key={index}
            className="bg-card rounded-xl p-6 text-center shadow-card hover:shadow-elevated transition-shadow duration-300">

              <div className="w-14 h-14 bg-accent/10 rounded-lg flex items-center justify-center mx-auto mb-4">
                <Icon name={stat.icon as any} size={28} variant="outline" className="text-accent" />
              </div>
              <p className="font-headline font-bold text-3xl text-primary mb-2">{stat.value}</p>
              <p className="text-sm text-muted-foreground font-body">{stat.label}</p>
            </div>
          )}
        </div>

        {/* Certifications Section */}
        <div className="mb-16">
          <h3 className="font-headline font-bold text-2xl text-primary text-center mb-8">
            Industry Certifications & Partnerships
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
            {certifications.map((cert, index) =>
            <div
              key={index}
              className="bg-card rounded-lg p-6 flex flex-col items-center justify-center shadow-card hover:shadow-elevated transition-all duration-300 hover:scale-105">

                <div className="w-20 h-20 rounded-lg overflow-hidden mb-3">
                  <AppImage
                  src={cert.image}
                  alt={cert.alt}
                  className="w-full h-full object-cover" />

                </div>
                <p className="text-sm font-cta font-semibold text-center text-foreground">
                  {cert.name}
                </p>
              </div>
            )}
          </div>
        </div>

        {/* Client Logos Section */}
        <div>
          <h3 className="font-headline font-bold text-2xl text-primary text-center mb-8">
            Trusted by Leading Organizations
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-6">
            {clientLogos.map((client, index) =>
            <div
              key={index}
              className="bg-card rounded-lg p-4 flex items-center justify-center shadow-card hover:shadow-elevated transition-all duration-300 hover:scale-105 grayscale hover:grayscale-0">

                <div className="w-full h-16 relative">
                  <AppImage
                  src={client.image}
                  alt={client.alt}
                  className="w-full h-full object-contain" />

                </div>
              </div>
            )}
          </div>
        </div>

        {/* Trust Badge */}
        <div className="mt-12 text-center">
          <div className="inline-flex items-center space-x-3 bg-success/10 px-6 py-4 rounded-full border border-success/20">
            <Icon name="ShieldCheckIcon" size={24} variant="solid" className="text-success" />
            <span className="font-cta font-bold text-success">
              Verified & Trusted IT Service Provider
            </span>
          </div>
        </div>
      </div>
    </section>);

};

export default TrustSignals;